import { BehaviorSubject } from 'rxjs';
import { NavigationItem } from './../@vex/interfaces/navigation-item.interface';
import { Component, HostListener, Inject, LOCALE_ID, OnDestroy, Renderer2 } from "@angular/core";
import { ConfigService } from "../@vex/services/config.service";
import { Settings } from "luxon";
import { DOCUMENT } from "@angular/common";
import { Platform } from "@angular/cdk/platform";
import { NavigationService } from "../@vex/services/navigation.service";
import icLayers from "@iconify/icons-ic/twotone-layers";
import perm_identity from "@iconify/icons-ic/twotone-layers";
import report_problem from "@iconify/icons-ic/report-problem";
import assignment from "@iconify/icons-ic/assignment";
import settings_overscan from "@iconify/icons-ic/settings-overscan";
import dashboard from "@iconify/icons-ic/dashboard";
import graphic_eq from "@iconify/icons-ic/graphic-eq";
import all_out from "@iconify/icons-ic/all-out";
import store from "@iconify/icons-ic/store";
import view_list from "@iconify/icons-ic/view-list";
import directions_walk from "@iconify/icons-ic/directions-walk";
import fa_tasks from "@iconify/icons-fa-solid/tasks";
import phone_android from "@iconify/icons-ic/phone-android";
import chat from "@iconify/icons-ic/chat";
import bubble_chart from "@iconify/icons-ic/bubble-chart";
import business from "@iconify/icons-ic/business";
import calendar_today from "@iconify/icons-ic/round-calendar-today";
import markunread_mailbox from "@iconify/icons-ic/markunread-mailbox";
import receipt from "@iconify/icons-ic/receipt";
import link from "@iconify/icons-ic/link";
import email from "@iconify/icons-ic/email";
import dvr from "@iconify/icons-ic/dvr";
import icAssigment from "@iconify/icons-ic/twotone-assignment";
import icContactSupport from "@iconify/icons-ic/twotone-contact-support";
import icDateRange from "@iconify/icons-ic/twotone-date-range";
import icChat from "@iconify/icons-ic/twotone-chat";
import icContacts from "@iconify/icons-ic/twotone-contacts";
import icAssessment from "@iconify/icons-ic/twotone-assessment";
import icLock from "@iconify/icons-ic/twotone-lock";
import icWatchLater from "@iconify/icons-ic/twotone-watch-later";
import icError from "@iconify/icons-ic/twotone-error";
import icAttachMoney from "@iconify/icons-ic/twotone-attach-money";
import icPersonOutline from "@iconify/icons-ic/twotone-person-outline";
import icReceipt from "@iconify/icons-ic/twotone-receipt";
import icHelp from "@iconify/icons-ic/twotone-help";
import icBook from "@iconify/icons-ic/twotone-book";
import icBubbleChart from "@iconify/icons-ic/twotone-bubble-chart";
import icFormatColorText from "@iconify/icons-ic/twotone-format-color-text";
import icStar from "@iconify/icons-ic/twotone-star";
import icViewCompact from "@iconify/icons-ic/twotone-view-compact";
import icPictureInPicture from "@iconify/icons-ic/twotone-picture-in-picture";
import icSettings from "@iconify/icons-ic/twotone-settings";
import { LayoutService } from "../@vex/services/layout.service";
import icUpdate from "@iconify/icons-ic/twotone-update";
import { ActivatedRoute, NavigationEnd, Route, Router } from "@angular/router";
import { filter, map } from "rxjs/operators";
import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { SplashScreenService } from "../@vex/services/splash-screen.service";
import { Style, StyleService } from "../@vex/services/style.service";
import icChromeReaderMode from "@iconify/icons-ic/twotone-chrome-reader-mode";
import { ConfigName } from "../@vex/interfaces/config-name.model";
import icMail from "@iconify/icons-ic/twotone-mail";
import { User } from "./models/user";
import { LeadService } from './pages/services/lead/lead.service';
import { AppUpdateService } from './services/app-update.service';
import { StoreService } from './pages/services/stores/store.service';
import { UtilService } from './pages/services/util/util.service';
import { AuthService } from './pages/services/auth/auth.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: "vex-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnDestroy{
    title = "vex";
    loggedinUser: User;
    notifications = new BehaviorSubject<any[]>([]);
    FILTERS = new BehaviorSubject<any[]>([]);
    loginMode : string = "OTP";
    url: string;
    lastUrlSegment: string;
    resetpass: boolean = false;



    constructor(
        private configService: ConfigService,
        private styleService: StyleService,
        private renderer: Renderer2,
        private updateService:AppUpdateService,
        private platform: Platform,
        @Inject(DOCUMENT) private document: Document,
        @Inject(LOCALE_ID) private localeId: string,
        private layoutService: LayoutService,
        private route: ActivatedRoute,
        private navigationService: NavigationService,
        private splashScreenService: SplashScreenService,
        private leadSerivce : LeadService,
        private util : UtilService,
        private router : Router,
        private auth: AuthService,
        private titleService: Title
    ) {

        // this.auth.loginMode().then( data =>{
        //     if(data.status == 'SUCCESS'){
        //         this.loginMode = data.desc;
        //     }
        // })

        Settings.defaultLocale = this.localeId;

        if (this.platform.BLINK) {
            this.renderer.addClass(this.document.body, "is-blink");
        }

        const color = {
            light: "rgba(0, 118, 206, 1)",
            default: "rgb(0, 118, 206)",
            contrast: "rgb(255, 255, 255)",
        };
        if (this.document) {
            this.document.documentElement.style.setProperty(
                "--color-primary",
                color.default.replace("rgb(", "").replace(")", "")
            );
            this.document.documentElement.style.setProperty(
                "--color-primary-contrast",
                color.contrast.replace("rgb(", "").replace(")", "")
            );
        }

        /**
         * Customize the template to your needs with the ConfigService
         * Example:
         *  this.configService.updateConfig({
         *    sidenav: {
         *      title: 'Custom App',
         *      imageUrl: '//placehold.it/100x100',
         *      showCollapsePin: false
         *    },
         *    footer: {
         *      visible: false
         *    }
         *  });
         */

        /**
         * Config Related Subscriptions
         * You can remove this if you don't need the functionality of being able to enable specific configs with queryParams
         * Example: example.com/?layout=apollo&style=default
         */
        this.route.queryParamMap
            .pipe(
                filter((queryParamMap) => queryParamMap.has("rtl")),
                map((queryParamMap) =>
                    coerceBooleanProperty(queryParamMap.get("rtl"))
                )
            )
            .subscribe((isRtl) => {
                this.configService.updateConfig({
                    rtl: isRtl,
                });
            });

        this.route.queryParamMap
            .pipe(filter((queryParamMap) => queryParamMap.has("layout")))
            .subscribe((queryParamMap) =>
                this.configService.setConfig(
                    queryParamMap.get("layout") as ConfigName
                )
            );

        this.route.queryParamMap
            .pipe(filter((queryParamMap) => queryParamMap.has("style")))
            .subscribe((queryParamMap) =>
                this.styleService.setStyle(queryParamMap.get("style") as Style)
            );

        /**
         * Add your own routes here
         */
        this.route.url.subscribe(activeUrl => {
            this.url = window.location.pathname;
            this.lastUrlSegment = this.url.substring(this.url.lastIndexOf("/") + 1);
            console.log(this.lastUrlSegment);
            if(this.lastUrlSegment == "reset-password"){
            this.resetpass = true;
            // if(this.lastUrlSegment == "login"){
            //     this.router.navigate(['/']);
            // }
            }
        });

        this.checkIfLoggedIn();
       let user = localStorage.getItem('user');
       if(user == undefined && !this.resetpass){
        this.router.navigate(["/"])
       }
    }


    ngOnInit() {
        this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(() => {
            const currentUrl = this.router.url;

            let pageTitle = 'Dell | LMS';

            if (currentUrl.includes('/leads/list')) {
              pageTitle = 'Leads | Dell | LMS';
            } if (currentUrl.includes('/leads/vfn')) {
              pageTitle = 'VFN | Dell | LMS';
            } if (currentUrl.includes('/leads/walkin')) {
              pageTitle = 'Walkin | Dell | LMS';
            } if (currentUrl.includes('/leads/servicetags')) {
              pageTitle = 'Product - Service | Dell | LMS';
            } if (currentUrl.includes('/leads/lead-forwarding')) {
              pageTitle = 'Lead Forwarding | Dell | LMS';
            } else if (currentUrl.includes('/stores/list')) {
              pageTitle = 'Stores | Dell | LMS';
            } else if (currentUrl.includes('/stores/activate')) {
              pageTitle = 'Stores | Dell | LMS';
            } else if (currentUrl.includes('/stores/partnerlogs')) {
              pageTitle = 'Partner | Dell | LMS';
            } else if (currentUrl.includes('/dashboard')) {
              pageTitle = 'Dashboard | Dell | LMS';
            } else if (currentUrl.includes('/content/store/locator/page')) {
              pageTitle = 'Store Locator | Dell | LMS';
            } else if (currentUrl.includes('/content/latest/offer/page')) {
              pageTitle = 'Latest Offer | Dell | LMS';
            } else if (currentUrl.includes('/content/gmb-offers-post')) {
              pageTitle = 'GMB Offer | Dell | LMS';
            } else if (currentUrl.includes('/content/faqs')) {
              pageTitle = 'FAQ | Dell | LMS';
            } else if (currentUrl.includes('/campaign/list')) {
              pageTitle = 'Campaign | Dell | LMS';
            } else if (currentUrl.includes('/campaign/template/list')) {
              pageTitle = 'Template | Dell | LMS';
            } else if (currentUrl.includes('/campaign/voucher/list')) {
              pageTitle = 'Voucher | Dell | LMS';
            } else if (currentUrl.includes('/campaign/reimbursment/list')) {
              pageTitle = 'Reimbursment | Dell | LMS';
            } else if (currentUrl.includes('/report-generate/log')) {
              pageTitle = 'Reports Log | Dell | LMS';
            } else if (currentUrl.includes('/report-generate/list')) {
              pageTitle = 'Reports | Dell | LMS';
            } else if (currentUrl.includes('/rmn')) {
              pageTitle = 'RMN | Dell | LMS';
            }
            this.titleService.setTitle(pageTitle);
          });
    }







    getFiltersForUser():void {
       this.leadSerivce.getAllFilters().then((data)=>{
           if(data.length>0){
                this.FILTERS.next(data);
           }
       })}


    ngOnDestroy(): void {
        localStorage.clear();
        throw new Error('Method not implemented.');

    }


    checkIfLoggedIn() {
        const user: User = JSON.parse(localStorage.getItem('user'));
        this.loggedinUser = user;
        if (user) {
            // this.buildMenu(user.privileges.filter(p => p.menu === true));/
            this.buildNewMenu(user.menus);
            // this.getLeadTags()
        }

    }
 buildNewMenu(privileges : any){
    this.navigationService.items = [];
    for (let menuItem of privileges) {
        menuItem.icon = this.setIcon(menuItem.icon);
        this.setNavigationMenuItem(menuItem)
       }
 }

    buildMenu(privileges: import("./models/user").Privilege[] | any) {
        for(let p of privileges){
            if(p.label==='Dashboard'){
                p.order=0;
            }else{
                p.order=1;
            }
        }
        privileges.sort((a,b)=> a.order<b.order?-1:a.order===b.order?0:1);

        this.navigationService.items = [];

        let newGroup = this.util.groupByRoleName(privileges, p => p.category);
        newGroup = new Map([...newGroup.entries()].sort());
        privileges = []
        newGroup.forEach((value, key)=>{
        if(value && value.length > 1){
          let splited =  key.split("_");
         splited =  splited.map((c:string) => c.toLowerCase())
         let newSplited = splited.map((c : string) => capitalizeFirstLetter(c));
         let joined = newSplited.join(" ");
            let obj = {
                type: "dropdown",
                label: joined,
                icon:this.setIcon(value[0].icon),
                children : []
            }
            value.forEach(element => {
                obj.children.push({
                    type: "link",
                    label: element.label,
                    route: element.route,
                })
            });

            privileges.push(obj);

        }else{
            let splited =  key.split("_");
            splited =  splited.map((c:string) => c.toLowerCase())
            let newSplited = splited.map((c : string) => capitalizeFirstLetter(c));
            let joined = newSplited.join(" ");
            privileges.push({
                type: "link",
                label: joined,
                route: value[0].route,
                icon: this.setIcon(value[0].icon),
                routerLinkActiveOptions: { exact: true },
            })
        }
       })

       function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    //    console.log("new Group ", privileges);
        // privileges =
        // [
        //         {
        //             type: "link",
        //             label: "Dashboard",
        //             route: "/dashboard",
        //             icon: dashboard,
        //             routerLinkActiveOptions: { exact: true },
        //         },

        //         {
        //             type: "dropdown",
        //             label: "Lead Management",
        //             icon: view_list,
        //             children: [
        //                 {
        //                     type: "link",
        //                     label: "View / Edit Leads",
        //                     route: "/leads/list",
        //                 },
        //                 {
        //                     type: "link",
        //                     label: "VFN Lead Listing",
        //                     route: "/leads/vfn",
        //                 },
        //                 {
        //                     type: "link",
        //                     label: "Walkins",
        //                     route: "/leads/walkin",
        //                 },
        //             ],
        //         },
        //         {
        //             type: "dropdown",
        //             label: "Store Management",
        //             icon: store,
        //             children: [
        //                 {
        //                     type: "link",
        //                     label: "Stores",
        //                     route: "/stores",
        //                 },
        //                 {
        //                     type : "link",
        //                     label : "Activate Partner",
        //                     route :"/stores/activate"
        //                 },
        //                 {
        //                     type: "link",
        //                     label: "Partner Logs",
        //                     route: "/stores/partnerlogs",
        //                 }
        //             ],
        //         },
        //         {
        //             type: "dropdown",
        //             label: "Content Management",
        //             icon: graphic_eq,
        //             children: [
        //                 {
        //                     type: "link",
        //                     label: "GMB post",
        //                     route: "/stores/gmblik",
        //                 },
        //                 {
        //                     type: "link",
        //                     label: "Store Locator",
        //                     route: "/stores/storelocator",
        //                 }
        //             ],
        //         },
        //         {
        //             type: "dropdown",
        //             label: "Communication",
        //             icon: email,
        //             children: [
        //                 {
        //                     type: "link",
        //                     label: "GMB reviews",
        //                     route: "/stores/gmbreviews",
        //                 },
        //                 {
        //                     type : "link",
        //                     label : " Sms ",
        //                     route :"/stores/sms"
        //                 },
        //                 {
        //                     type: "link",
        //                     label: " Partner Helpdesk",
        //                     route: "/stores/partner/helpdesk",
        //                 },
        //                 {
        //                     type: "link",
        //                     label: "Customer Helpdesk",
        //                     route: "/stores/partner/helpdesk",
        //                 }
        //             ],
        //         }
        //     ];

   //console.log("privileges => ", privileges)

        // for (let menuItem of privileges) {
        //  this.setNavigationMenuItem(menuItem)
        // }
        /* this.setNavigationMenuItem({
            type: "link",
            label: "Walkins",
            route: "/leads/walkin",
            icon: icLayers,
            routerLinkActiveOptions: { exact: true },
        }) */
    }


    setIcon(icon:string): any{
        let selectedIcon = null;
        switch (icon) {
            case "icLayers":
                selectedIcon = icLayers;
              break;
            case "store":
                selectedIcon = store;
              break;
            case "view_list":
                selectedIcon = view_list;
              break;
            case "dashboard":
                selectedIcon = dashboard;
              break;
            case "phone_android":
                selectedIcon = phone_android;
                break;
            case "graphic_eq":
                selectedIcon = graphic_eq;
                break;
            case "email":
                selectedIcon = email;
                break;
            default:
              // Icon not found
              break;
          }
          return selectedIcon;
    }
    setNavigationMenuItem(menuItem: any) {
        this.navigationService.items.push(menuItem);
    }

    getNavigationMenuItems(): NavigationItem[] {
        return this.navigationService.items;
    }



}

